"use client";

/* "use client" DITAMBAHKAN, dan ini bukan pilihan gaya.

   Berkas ini sebelumnya sengaja TIDAK memakainya - komentar aslinya
   menulis bahwa Footer tidak punya state maupun event handler, jadi
   bisa dirender di peladen tanpa mengirim JavaScript ke browser.

   useLanguage() memakai React Context, dan Context hanya ada di
   browser. Begitu komponen membaca bahasa aktif, ia wajib jadi Client
   Component. Ini harga yang dibayar oleh SETIAP komponen yang teksnya
   diterjemahkan, dan tidak ada cara menghindarinya selama bahasa
   disimpan di state alih-alih di URL. */

import {
  Facebook,
  Instagram,
  Youtube,
  Linkedin,
  MapPin,
  Phone,
  Mail,
  Globe,
  MessageCircle,
  ListChecks,
} from "lucide-react";

import { useLanguage } from "../i18n/LanguageProvider";

/* `nama` TIDAK diterjemahkan: Facebook, Instagram, dan seterusnya
   adalah nama merek, sama di semua bahasa. Yang diterjemahkan adalah
   kalimat di sekitarnya lewat kunci footer.sosialAria. */
const SOSIAL = [
  { nama: "Facebook", Ikon: Facebook, href: "https://www.facebook.com/share/1ESz8VVyMf/" },
  { nama: "Instagram", Ikon: Instagram, href: "https://www.instagram.com/jmchospital" },
  {
    nama: "YouTube",
    Ikon: Youtube,
    href: "https://www.youtube.com/@rumahsakitjakartamedicalce2343",
  },
  { nama: "LinkedIn", Ikon: Linkedin, href: "https://www.linkedin.com/company/jmchospital/" },
];
const SURVEY_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfAvPqlRZauCQyk9wxBY-JX0WiZjGT9S1j8Ez3X_m4Q2JEBAg/viewform";

const PETA_URL = "https://maps.app.goo.gl/QCoy6kbDcjDrRGLB6";

const TELEPON_UTAMA = { label: "(021) 798 0888", href: "tel:+62217980888" };

const LAYANAN_247 = [
  {
    titleKey: "footer.cs",
    label: "0811 901 874",
    nomor: "62811901874",
    wa: true,
    sapaanKey: "footer.csSapaan",
  },
  {
    titleKey: "footer.asuransi",
    label: "0813 1800 2300",
    nomor: "6281318002300",
    wa: true,
    sapaanKey: "footer.asuransiSapaan",
  },
  {
    titleKey: "footer.bpjs",
    label: "0812 1208 777",
    nomor: "628121208777",
    wa: true,
    sapaanKey: "footer.bpjsSapaan",
  },
  {
    titleKey: "footer.komplain",
    label: "0815 801 7000",
    nomor: "628158017000",
    wa: true,
    sapaanKey: "footer.komplainSapaan",
  },
];

/* Tahun ditulis tetap, tidak diambil dari new Date().

   Alasannya: nilai yang berubah antara render server dan render klien
   adalah penyebab klasik hydration error, dan tanggal ikut terpengaruh
   zona waktu peladen. Untuk satu angka yang berubah setahun sekali,
   risikonya tidak sepadan. Ganti angka ini setiap Januari. */
const TAHUN = 2026;

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer>
      <div className="relative overflow-hidden bg-[var(--c-brand-strong)] px-4 py-12 text-white sm:px-6 sm:py-14 md:py-16 lg:px-10 xl:px-14">
        {/* MOTIF LATAR. aria-hidden karena murni tekstur. */}
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-[linear-gradient(45deg,#ffffff10_25%,transparent_25%,transparent_75%,#ffffff10_75%,#ffffff10),linear-gradient(-45deg,#ffffff10_25%,transparent_25%,transparent_75%,#ffffff10_75%,#ffffff10)] opacity-10 [background-size:80px_80px]"
        />

        {/* Di md kolom ketiga membentang penuh dan daftarnya jadi dua
           kolom, supaya tidak menyisakan satu sel kosong di sebelahnya.
           Di lg barulah ketiganya berjajar.

           LEBARNYA SEKARANG PENUH. Sebelumnya di sini ada
           `mx-auto max-w-[1600px]`, yang mengunci isi footer pada 1600px
           lalu memusatkannya. Di layar 1920px itu menyisakan sekitar
           160px kosong di kiri dan kanan - inilah "pembatas" yang
           terlihat pada tangkapan layar. Warna latarnya memang sudah
           membentang penuh; yang berhenti lebih awal adalah isinya.

           Sekarang tinggal padding milik pembungkus di atas yang menahan
           teks dari tepi layar: 16px di ponsel, naik ke 56px mulai xl.
           Padding tetap dipertahankan - teks yang menempel persis di
           tepi jendela sulit dibaca dan pada sebagian ponsel tertutup
           lengkungan sudut layar.

           ⚠️ KONSEKUENSI YANG PERLU KAMU PUTUSKAN: ContactBanner.jsx dan
           komponen lain di halaman ini MASIH memakai max-w-[1600px].
           Artinya di layar lebar, tepi kiri isi footer tidak lagi
           sejajar dengan tepi kiri section di atasnya - ada pergeseran
           sekitar 100px yang cukup terlihat kalau diperhatikan. Kalau
           yang kamu inginkan adalah seluruh situs jadi penuh, pembatas
           yang sama harus dilepas juga di komponen-komponen itu. */}
        <div className="relative grid w-full gap-10 md:grid-cols-2 md:gap-x-10 lg:grid-cols-3 lg:gap-12">
          {/* ---------- KOLOM 1: MEDIA SOSIAL ---------- */}
          <div>
            <JudulKolom>{t("footer.judulSosial")}</JudulKolom>

            <ul className="mb-8 flex flex-wrap gap-2 sm:gap-3">
              {SOSIAL.map(({ nama, Ikon, href }) => (
                <li key={nama}>
                  {href ? (
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={t("footer.sosialAria", { nama })}
                      className="group relative flex h-11 w-11 items-center justify-center rounded-xl text-[var(--c-on-brand-3)] transition-colors duration-300 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white motion-reduce:transition-none"
                    >
                      {/* Lingkaran latar memudar masuk. opacity, bukan
                         skala - tidak ada yang berubah ukuran di footer. */}
                      <span
                        aria-hidden="true"
                        className="absolute inset-0 rounded-xl bg-white/10 opacity-0 transition-opacity duration-300 group-hover:opacity-100 motion-reduce:transition-none"
                      />
                      <Ikon size={20} className="relative" />
                    </a>
                  ) : (
                    /* Belum ada URL: redup dan tidak bisa difokus. */
                    <span
                      title={t("footer.sosialBelumIsi", { nama })}
                      className="flex h-11 w-11 items-center justify-center rounded-xl text-[var(--c-on-brand-3)]/30"
                    >
                      <Ikon size={20} aria-hidden="true" />
                      <span className="sr-only">{t("footer.sosialBelumAda", { nama })}</span>
                    </span>
                  )}
                </li>
              ))}
            </ul>

            {SURVEY_URL ? (
              <a
                href={SURVEY_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.surveyAria")}
                className="group inline-flex items-center gap-2.5 rounded-xl bg-[var(--c-brand)] px-5 py-3 text-sm font-semibold text-white ring-1 ring-white/10 transition-colors duration-300 hover:bg-[var(--c-brand-mid)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white motion-reduce:transition-none sm:text-base"
              >
                <ListChecks
                  size={18}
                  className="text-[var(--c-on-brand-3)] transition-colors duration-300 group-hover:text-white motion-reduce:transition-none"
                />
                {t("footer.survey")}
              </a>
            ) : (
              <span
                title={t("footer.surveyBelum")}
                className="inline-flex cursor-not-allowed items-center gap-2.5 rounded-xl bg-[var(--c-brand)]/40 px-5 py-3 text-sm font-semibold text-white/40 ring-1 ring-white/10 sm:text-base"
              >
                <ListChecks size={18} aria-hidden="true" />
                {t("footer.survey")}
              </span>
            )}
          </div>

          {/* ---------- KOLOM 2: HUBUNGI KAMI ---------- */}
          <div>
            <JudulKolom>{t("footer.judulKontak")}</JudulKolom>

            <ul className="space-y-4">
              <li>
                <BarisKontak Ikon={MapPin} href={PETA_URL} eksternal aria={t("footer.petaAria")}>
                  {t("footer.alamat")}
                </BarisKontak>
              </li>

              <li>
                <BarisKontak
                  Ikon={Phone}
                  href={TELEPON_UTAMA.href}
                  aria={t("footer.teleponAria", { nomor: TELEPON_UTAMA.label })}
                >
                  {TELEPON_UTAMA.label}
                </BarisKontak>
              </li>

              <li>
                <BarisKontak
                  Ikon={Mail}
                  href="mailto:rsjmcid@rsjmc.id"
                  aria={t("footer.emailAria", { email: "rsjmcid@rsjmc.id" })}
                >
                  rsjmcid@rsjmc.id
                </BarisKontak>
              </li>

              <li>
                <BarisKontak
                  Ikon={Globe}
                  href="https://rsjmc.id/"
                  eksternal
                  aria={t("footer.situsAria")}
                >
                  rsjmc.id
                </BarisKontak>
              </li>
            </ul>
          </div>

          {/* ---------- KOLOM 3: LAYANAN 24/7 ---------- */}
          <div className="md:col-span-2 lg:col-span-1">
            <JudulKolom>{t("footer.judulLayanan")}</JudulKolom>

            <ul className="grid gap-2.5 md:grid-cols-2 lg:grid-cols-1">
              {LAYANAN_247.map((item) => (
                <li key={item.nomor}>
                  <KartuLayanan {...item} t={t} />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-[var(--c-panel)] px-4 py-5 text-center text-xs font-semibold text-[var(--c-on-brand-3)] sm:text-sm">
        {t("footer.copyright", { tahun: TAHUN })}
      </div>
    </footer>
  );
}

/* ============================================================
   JUDUL KOLOM

   Gaya eyebrow: kecil, kapital, berspasi lebar. Dipakai lewat komponen
   supaya ketiga kolom tidak pernah menyimpang satu sama lain.
   ============================================================ */

function JudulKolom({ children }) {
  return (
    <h3 className="mb-5 text-[11px] font-semibold uppercase tracking-[0.16em] text-[var(--c-on-brand-3)] sm:mb-6 sm:text-xs sm:tracking-[0.18em]">
      {children}
    </h3>
  );
}

/* ============================================================
   BARIS KONTAK

   items-start, bukan items-center. Alamatnya empat baris; kalau ikon
   dirata-tengahkan terhadap seluruh blok, ia melayang di tengah
   paragraf alih-alih sejajar dengan baris pertama.
   ============================================================ */

function BarisKontak({ Ikon, href, children, aria, eksternal = false }) {
  const luar = eksternal ? { target: "_blank", rel: "noopener noreferrer" } : {};

  return (
    <a
      href={href}
      aria-label={aria}
      {...luar}
      className="group flex items-start gap-3 rounded-lg text-sm leading-relaxed text-[var(--c-on-brand-1)]/85 transition-colors duration-300 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white motion-reduce:transition-none sm:text-[15px]"
    >
      <Ikon
        size={18}
        aria-hidden="true"
        className="mt-0.5 shrink-0 text-[var(--c-on-brand-3)] transition-colors duration-300 group-hover:text-white motion-reduce:transition-none"
      />
      <span>{children}</span>
    </a>
  );
}

/* ============================================================
   KARTU LAYANAN 24/7

   Batang tegak di tepi kiri tumbuh dari TENGAH ke atas dan bawah
   (origin-center + scale-y). Sumbunya vertikal, berbeda dari garis
   mendatar yang menggambar di section Kenapa Kami.

   Nomor memakai tabular-nums supaya lebar tiap angka sama, jadi keempat
   nomor tersusun rapi meski jumlah digitnya berbeda.

   TAUTAN WHATSAPP memakai wa.me - format resmi WhatsApp, dan satu-
   satunya yang bekerja di semua lingkungan sekaligus:
     ponsel dengan WhatsApp  -> aplikasi langsung terbuka
     ponsel tanpa WhatsApp   -> diarahkan ke halaman unduh
     desktop                 -> web.whatsapp.com atau aplikasi desktop
   Skema api.whatsapp.com/send juga jalan tapi lebih panjang, sedangkan
   whatsapp:// hanya jalan kalau aplikasinya terpasang.

   Nomor pada wa.me DITULIS TANPA tanda + dan tanpa spasi. Ini bukan
   selera penulisan: wa.me memperlakukan karakter selain angka sebagai
   bagian dari path dan gagal mengenali nomornya.

   target="_blank" dipakai untuk WhatsApp, TIDAK untuk tel:. Chat
   WhatsApp adalah tujuan lain yang bisa memakan waktu lama; kalau
   dibuka di tab yang sama, pengunjung kehilangan situs RS dan harus
   menekan tombol kembali berkali-kali. Sebaliknya tel: tidak pernah
   berpindah halaman - ia hanya memanggil aplikasi telepon - jadi
   target="_blank" di sana justru meninggalkan tab kosong.

   IKONNYA IKUT BERUBAH mengikuti tujuan tautan: gelembung chat untuk
   WhatsApp, gagang telepon untuk tel:. Versi sebelumnya memakai
   gelembung chat untuk semuanya padahal semua tautannya tel: - ikon
   yang menjanjikan chat lalu membuka panggilan telepon adalah hal
   pertama yang membuat orang ragu menekan tombol.
   ============================================================ */

function KartuLayanan({ titleKey, label, nomor, wa = false, sapaanKey, t }) {
  /* Sapaan ikut berbahasa Inggris kalau pengunjung memilih English.
     Kalau tidak, pengunjung asing menekan tombol lalu WhatsApp terbuka
     dengan kalimat Indonesia yang tidak ia mengerti dan tidak bisa ia
     nilai apakah sesuai maksudnya. */
  const sapaan = sapaanKey ? t(sapaanKey) : "";
  const title = t(titleKey);

  const href = wa
    ? `https://wa.me/${nomor}${sapaan ? `?text=${encodeURIComponent(sapaan)}` : ""}`
    : `tel:+${nomor}`;

  const luar = wa ? { target: "_blank", rel: "noopener noreferrer" } : {};

  const aria = wa
    ? t("footer.waAria", { peran: title, nomor: label })
    : t("footer.telAria", { peran: title, nomor: label });

  const Ikon = wa ? MessageCircle : Phone;

  return (
    <a
      href={href}
      aria-label={aria}
      {...luar}
      className="group relative flex items-center gap-3.5 overflow-hidden rounded-xl bg-[var(--c-brand)]/70 px-4 py-3 ring-1 ring-white/10 transition-colors duration-300 hover:bg-[var(--c-brand)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white motion-reduce:transition-none sm:px-5"
    >
      <span
        aria-hidden="true"
        className="absolute inset-y-0 left-0 w-[3px] origin-center scale-y-0 bg-[var(--c-surface)] transition-transform duration-300 ease-out group-hover:scale-y-100 motion-reduce:transition-none"
      />

      <Ikon
        size={20}
        aria-hidden="true"
        className="shrink-0 text-[var(--c-on-brand-3)] transition-colors duration-300 group-hover:text-white motion-reduce:transition-none"
      />

      <span className="min-w-0">
        <span className="block text-sm font-semibold text-white">{title}</span>
        <span className="block text-xs tabular-nums text-[var(--c-on-brand-2)]/80 sm:text-sm">
          {label}
        </span>
      </span>
    </a>
  );
}
